"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockPassportWaitlistFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockPassportWaitlistFactory = /** @class */ (function (_super) {
    __extends(MockPassportWaitlistFactory, _super);
    function MockPassportWaitlistFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockPassportWaitlistFactory.prototype.deploy = function (_paymentToken, _paymentAmount, _paymentReceiver, overrides) {
        return _super.prototype.deploy.call(this, _paymentToken, _paymentAmount, _paymentReceiver, overrides || {});
    };
    MockPassportWaitlistFactory.prototype.getDeployTransaction = function (_paymentToken, _paymentAmount, _paymentReceiver, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _paymentToken, _paymentAmount, _paymentReceiver, overrides || {});
    };
    MockPassportWaitlistFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockPassportWaitlistFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockPassportWaitlistFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockPassportWaitlistFactory;
}(contracts_1.ContractFactory));
exports.MockPassportWaitlistFactory = MockPassportWaitlistFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_paymentToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_paymentAmount",
                type: "uint256",
            },
            {
                internalType: "address payable",
                name: "_paymentReceiver",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_paymentToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_paymentAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_paymentReceiver",
                type: "address",
            },
        ],
        name: "PaymentSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_paymentToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_paymentAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_timestamp",
                type: "uint256",
            },
        ],
        name: "UserApplied",
        type: "event",
    },
    {
        inputs: [],
        name: "applyForPassport",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_users",
                type: "address[]",
            },
        ],
        name: "applyOnBehalf",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "currentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "payableApplyForPassport",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "paymentAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "paymentReceiver",
        outputs: [
            {
                internalType: "address payable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "paymentToken",
        outputs: [
            {
                internalType: "contract IPermittableERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "_v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "_r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_s",
                type: "bytes32",
            },
        ],
        name: "permitApplyForPassport",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timestamp",
                type: "uint256",
            },
        ],
        name: "setCurrentTimestamp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_paymentToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_paymentAmount",
                type: "uint256",
            },
            {
                internalType: "address payable",
                name: "_paymentReceiver",
                type: "address",
            },
        ],
        name: "setPayment",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
